module.exports = __webpack_public_path__ + "static/media/4 things that has the same shape.f7df9a3a.mp3";